import md5 from 'js-md5';

//安全验证，防用户篡改
export function safeFn(userId) {
	
	let userIdStr = md5(userId + 'rjdd_web');
	let sessionData = localStorage.getItem('userIdStr');
	
	if(userIdStr != sessionData) {
		uni.navigateTo({
			url: '/pages/login/loginpage/index'
		});
	}
	
}


